var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 157.846,
    viewBox: "0 0 224 157.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6674",
    "data-name": "Path 6674",
    d: "M275.182,176.726H260.516a5.322,5.322,0,0,0-5.318,5.318v15.9c-.188-.011-.375-.028-.56-.05A18.751,18.751,0,1,1,275.1,176.167C275.129,176.351,275.157,176.539,275.182,176.726Z",
    transform: "translate(-224.223 -160.495)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    d: "M485.72,216.5H303.54a5.8,5.8,0,0,0-5.7,5.877v99.077a5.8,5.8,0,0,0,5.7,5.877H485.72a5.8,5.8,0,0,0,5.7-5.877V222.373A5.8,5.8,0,0,0,485.72,216.5Zm5.159,104.954a5.245,5.245,0,0,1-5.159,5.318H303.54a5.245,5.245,0,0,1-5.159-5.318V222.373a5.245,5.245,0,0,1,5.159-5.318H485.72a5.245,5.245,0,0,1,5.159,5.318Z",
    transform: "translate(-267.422 -200.824)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M520.444,272.425H351.118a.28.28,0,1,1,0-.56H520.444a.28.28,0,0,1,0,.56Z",
    transform: "translate(-311.557 -240.697)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M522.118,331.135a.28.28,0,0,1-.28-.28v-92.08a.28.28,0,0,1,.56,0v92.08A.28.28,0,0,1,522.118,331.135Z",
    transform: "translate(-431.152 -216.667)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M673.118,331.135a.28.28,0,0,1-.28-.28v-92.08a.28.28,0,1,1,.56,0v92.08A.28.28,0,0,1,673.118,331.135Z",
    transform: "translate(-540.99 -216.667)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M824.118,331.135a.28.28,0,0,1-.28-.28v-92.08a.28.28,0,1,1,.56,0v92.08A.28.28,0,0,1,824.118,331.135Z",
    transform: "translate(-650.828 -216.667)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M396.2,339.55H385.973a1.261,1.261,0,0,1-1.259-1.259V326.222a1.261,1.261,0,0,1,1.259-1.259H396.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,396.2,339.55Z",
    transform: "translate(-331.487 -280.247)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M448.2,462.55H437.973a1.261,1.261,0,0,1-1.259-1.259V449.222a1.261,1.261,0,0,1,1.259-1.259H448.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,448.2,462.55Z",
    transform: "translate(-369.333 -369.804)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6682",
    "data-name": "Path 6682",
    d: "M566.2,365.55H555.973a1.261,1.261,0,0,1-1.259-1.259V352.222a1.261,1.261,0,0,1,1.259-1.259H566.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,566.2,365.55Z",
    transform: "translate(-455.215 -299.178)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    d: "M719.2,318.55H708.973a1.261,1.261,0,0,1-1.259-1.259V305.222a1.261,1.261,0,0,1,1.26-1.259H719.2a1.261,1.261,0,0,1,1.26,1.259v12.068A1.261,1.261,0,0,1,719.2,318.55Z",
    transform: "translate(-566.571 -264.957)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6684",
    "data-name": "Path 6684",
    d: "M860.2,318.55H849.973a1.261,1.261,0,0,1-1.259-1.259V305.222a1.261,1.261,0,0,1,1.259-1.259H860.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,860.2,318.55Z",
    transform: "translate(-670.089 -264.957)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    d: "M925.2,330.55H914.973a1.261,1.261,0,0,1-1.259-1.259V317.222a1.261,1.261,0,0,1,1.259-1.259H925.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,925.2,330.55Z",
    transform: "translate(-716.897 -273.694)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    "data-name": "Path 6686",
    d: "M896.2,407.55H885.973a1.261,1.261,0,0,1-1.259-1.259V394.222a1.261,1.261,0,0,1,1.259-1.259H896.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,896.2,407.55Z",
    transform: "translate(-696.013 -329.758)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M772.2,391.55H761.973a1.261,1.261,0,0,1-1.259-1.259V378.222a1.261,1.261,0,0,1,1.259-1.259H772.2a1.261,1.261,0,0,1,1.26,1.259v12.068A1.261,1.261,0,0,1,772.2,391.55Z",
    transform: "translate(-605.145 -318.108)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M701.2,407.55H690.973a1.261,1.261,0,0,1-1.259-1.259V394.222a1.261,1.261,0,0,1,1.259-1.259H701.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,701.2,407.55Z",
    transform: "translate(-553.47 -329.758)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M548.2,475.55H537.973a1.261,1.261,0,0,1-1.259-1.259V462.222a1.261,1.261,0,0,1,1.26-1.259H548.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,548.2,475.55Z",
    transform: "translate(-442.115 -379.269)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M363.2,418.55H352.973a1.261,1.261,0,0,1-1.259-1.259V405.222a1.261,1.261,0,0,1,1.259-1.259H363.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,363.2,418.55Z",
    transform: "translate(-307.469 -337.767)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    d: "M466.2,339.55H455.973a1.261,1.261,0,0,1-1.259-1.259V326.222a1.261,1.261,0,0,1,1.259-1.259H466.2a1.261,1.261,0,0,1,1.259,1.259v12.068A1.261,1.261,0,0,1,466.2,339.55Z",
    transform: "translate(-382.434 -280.247)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M421.911,251.734H405.958a1.12,1.12,0,0,1,0-2.239h15.953a1.12,1.12,0,0,1,0,2.239Z",
    transform: "translate(-346.176 -224.588)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    d: "M582.911,251.734H566.958a1.12,1.12,0,0,1,0-2.239h15.953a1.12,1.12,0,0,1,0,2.239Z",
    transform: "translate(-463.386 -224.588)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M733.911,251.734H717.958a1.12,1.12,0,1,1,0-2.239h15.953a1.12,1.12,0,0,1,0,2.239Z",
    transform: "translate(-573.316 -224.588)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M874.911,251.734H858.958a1.12,1.12,0,0,1,0-2.239h15.953a1.12,1.12,0,1,1,0,2.239Z",
    transform: "translate(-676.659 -224.588)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M313.447,521.56A2.814,2.814,0,0,1,311.012,518l-7.174-6.678,3.793-.962,7.055,5.722a2.83,2.83,0,0,1-1.239,5.482Z",
    transform: "translate(-271.743 -415.171)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M184.4,532.2h3.431l1.632-13.235H184.4Z",
    transform: "translate(-134.162 -377.926)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M0,0H10.784V4.166H4.167A4.166,4.166,0,0,1,0,0H0Z",
    transform: "translate(60.273 157.46) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    d: "M100.345,524.494l3.316.883,4.982-12.369-4.894-1.3Z",
    transform: "translate(-72.261 -372.698)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M0,0H10.784V4.167H4.167A4.167,4.167,0,0,1,0,0H0Z",
    transform: "matrix(-0.966, -0.257, 0.257, -0.966, 36.975, 157.461)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    d: "M315.826,560.93H310.59a1.324,1.324,0,0,1-1.323-1.2l-3.178-33.006a1.049,1.049,0,0,0-2.049-.2l-9.229,30.842a1.327,1.327,0,0,1-1.6.909l-4.871-1.218a1.329,1.329,0,0,1-.965-1.62c.08-.311,7.952-31.074,8.02-31.391,1.784-13.145,3.917-16.668,5.064-18.56.095-.157.182-.3.261-.437.1-.17.7-1.86,1.087-2.957a1.341,1.341,0,0,1,.682-.833c4.817-2.463,10.453-.758,12.065-.177a1.31,1.31,0,0,1,.654.508c4.838,7.3,2.464,49.676,1.939,58.1A1.33,1.33,0,0,1,315.826,560.93Z",
    transform: "translate(-259.861 -409.162)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 6.874,
    cy: 6.874,
    r: 6.874,
    transform: "translate(34.597 56.96)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M317.09,450.458l-.049-.048c-.093-.09-9.252-9.062-8.066-17.359.507-3.549,3.378-5.816,8.3-6.558a7.594,7.594,0,0,1,8.4,5.352l4.87,16.648Z",
    transform: "translate(-275.365 -354.257)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M301.929,470.782,295.4,464.3a3.677,3.677,0,0,1-.974-3.468l3.159-12.852a2.9,2.9,0,1,1,5.594,1.51l-3.326,11.306,5.379,5.776Z",
    transform: "translate(-264.892 -368.381)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6704",
    "data-name": "Path 6704",
    d: "M413.431,445.68a2.814,2.814,0,0,1-4.166,1.128l-8.712,4.516.385-3.836,7.724-4.78a2.83,2.83,0,0,1,4.769,2.973Z",
    transform: "translate(-343.018 -365.133)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M366.543,441.326,358.049,445a3.585,3.585,0,0,1-3.492-.375l-10.8-7.738a2.9,2.9,0,1,1,3.48-4.633l9.261,7.289,7.361-2.848Z",
    transform: "translate(-300.862 -357.902)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M302.366,374.806c.848-1.063,2.432-1.12,3.6-1.821a4.2,4.2,0,0,0,1.665-4.681,5.873,5.873,0,0,0-3.6-3.683,9.947,9.947,0,0,0-5.266-.337,10.693,10.693,0,0,0-6.775,3.8,6.694,6.694,0,0,0-.555,7.448c.663,1.022,1.687,1.866,1.952,3.055.348,1.562-.748,3.068-1.921,4.155a43.638,43.638,0,0,0-4.042,3.673A5.6,5.6,0,0,0,286,391.459a5.1,5.1,0,0,0,3.18,3.074,13.477,13.477,0,0,0,4.512.646,7.623,7.623,0,0,0,4.306-.806,5.008,5.008,0,0,0,2.1-4.066,9.628,9.628,0,0,0-1.188-4.56,17.536,17.536,0,0,1-1.2-2.569,3.6,3.6,0,0,1,.121-2.76,3.442,3.442,0,0,1,2.408-1.594c.051-.01.1-.019.16-.027a2.071,2.071,0,0,0,1.773-2.415A2.022,2.022,0,0,1,302.366,374.806Z",
    transform: "translate(-258.773 -308.937)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6707",
    "data-name": "Path 6707",
    d: "M470.2,533.247h-3.431l-1.632-13.235H470.2Z",
    transform: "translate(-338.411 -378.68)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6708",
    "data-name": "Path 6708",
    d: "M451.492,563.8h6.617v4.167H447.325A4.167,4.167,0,0,1,451.492,563.8Z",
    transform: "translate(-325.538 -410.21)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6709",
    "data-name": "Path 6709",
    d: "M546.184,522.438l-3.121,1.425-6.984-11.36,4.607-2.1Z",
    transform: "translate(-390.116 -371.758)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6710",
    "data-name": "Path 6710",
    d: "M4.166,0h6.617V4.166H0A4.166,4.166,0,0,1,4.166,0Z",
    transform: "translate(146.478 153.964) rotate(-24.548)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    d: "M713.947,533.715a2.814,2.814,0,0,0,.224-4.31l4.033-9.152-5.124.868-3.045,8.558a2.83,2.83,0,0,0,3.911,4.036Z",
    transform: "translate(-567.728 -422.428)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6712",
    "data-name": "Path 6712",
    d: "M655.335,586.023h-3.278a1.264,1.264,0,0,1-1.256-1.168l-1.788-47.736a1.259,1.259,0,0,1,1.379-1.345l18.957,2.013a1.26,1.26,0,0,1,1.137,1.23l.4,21.057a.978.978,0,0,0,.065.334l7.776,20.166a1.259,1.259,0,0,1-.74,1.635l-3.322,1.224a1.26,1.26,0,0,1-1.555-.606l-9.553-18.575a1.254,1.254,0,0,1-.113-.32l-1.632-7.863a.98.98,0,0,0-1.932.087l-3.292,28.75A1.259,1.259,0,0,1,655.335,586.023Z",
    transform: "translate(-524.147 -434.946)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 6.874,
    cy: 6.874,
    r: 6.874,
    transform: "translate(126.202 53.738)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6713",
    "data-name": "Path 6713",
    d: "M660.359,456.608a24.535,24.535,0,0,1-13.119-3.974l-.067-.046.007-.081,2.629-30.623a4.316,4.316,0,0,1,4.086-3.935c3.408-.157,7.985.041,10.435,1.866a11.949,11.949,0,0,1,4.9,11.394c-1.226,9.3.163,21.839.325,23.238l.012.1-.092.042A21.625,21.625,0,0,1,660.359,456.608Z",
    transform: "translate(-522.672 -348.321)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6714",
    "data-name": "Path 6714",
    d: "M714.487,472.693a1.4,1.4,0,0,1-1.03-.454l-1.5-1.64a1.407,1.407,0,0,1-.31-1.342l3.429-11.6L709.855,446.7a2.465,2.465,0,0,1,4.4-2.229l7.079,11.487a3.345,3.345,0,0,1,.2,3.134l-5.768,12.781a1.4,1.4,0,0,1-1.054.806A1.413,1.413,0,0,1,714.487,472.693Z",
    transform: "translate(-567.945 -366.569)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    d: "M550.926,456.3a2.814,2.814,0,0,0,4.2-1l9.918,1.286-2.279-4.671-9.069-.505a2.83,2.83,0,0,0-2.767,4.891Z",
    transform: "translate(-451.65 -372.017)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6716",
    "data-name": "Path 6716",
    d: "M587.084,434.247a3.756,3.756,0,0,1-.516-.036l-15.6-2.164a1.551,1.551,0,0,1-1.19-.871,1.572,1.572,0,0,1-.089-.232h0a1.557,1.557,0,0,1,.161-1.24l1.291-2.141a1.563,1.563,0,0,1,1.331-.752h0l13.6.016,10.158-9.1A2.753,2.753,0,0,1,600,421.733l-10.136,11.273A3.74,3.74,0,0,1,587.084,434.247Z",
    transform: "translate(-466.338 -347.314)",
    fill: "#122aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6717",
    "data-name": "Path 6717",
    d: "M655.072,364.042c.628-1.454,1.16-3.39-.045-4.418a4.464,4.464,0,0,0-2.621-.672c-2.58-.209-5.235-1.4-6.5-3.656s-.557-5.621,1.822-6.641c1.6-.687,3.442-.219,5.12.257l5.039,1.429a8.889,8.889,0,0,1,4.148,2.016c1.719,1.79,1.591,4.817.225,6.89s-3.422,4.235-5.776,5.022Z",
    transform: "translate(-521.227 -297.259)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6718",
    "data-name": "Path 6718",
    d: "M390.168,737.79H189.486a.333.333,0,0,1,0-.667H390.168a.333.333,0,0,1,0,.667Z",
    transform: "translate(-189.162 -579.946)",
    fill: "#3f3d56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.3c6ceaaf.svg";
export { ForwardRef as ReactComponent };